export default {
    props: {
        toggleFilterVisibilityOnMobile: { type: Boolean, default: true },
    },
    data() {
        return {
            showFilterCardOnXs: true,
        }
    },
    computed: {
        showToggleFilterVisibility() {
            return this.toggleFilterVisibilityOnMobile && this.$vuetify.breakpoint.xsOnly;
        },
        isFilterCardVisible() {
            if (!this.showToggleFilterVisibility) { return true }
            return this.showFilterCardOnXs;
        },
    }

}